export const dashInvoices = {
  invoices: {
    title: "Invoices to send",
    subtitle: "Here you'll see requests awaiting invoice issuance.",
    loading: "Loading…",
    empty: "No invoices to send.",
    guestFallback: "Guest",
    manualBadge: "Manual",
    manualBadgeTitle: "Not generated automatically: you issue it manually",
    manualCheckoutTitle: "Not generated automatically: issue it manually",
    linkSentTitle: "Link sent to the guest",
    linkPendingTitle: "The link will be sent on check-out day",
    manualIssue: "Manual issuance",
    sendLinkTitle: "Send the guest the link to complete their invoice details",
    resend: "Resend",
    sendLink: "Send link",
    closeRequestTitle: "Close this request (you issue it manually)",
    close: "Close",
    cancelAutoTitle: "Cancel automatic sending to send it manually by another means",
    cancel: "Cancel",
    viewAll: "View all invoices",
    confirmCancel: {
      title: "Cancel automatic sending?",
      html: "The invoice link won't be sent to the guest.<br>You'll be able to send it manually by another means.",
      confirm: "Yes, cancel",
      cancel: "No",
    },
    confirmSend: {
      title: "Send the invoice link?",
      html: "The link to complete their tax details will be sent to the guest via WhatsApp.<br>You issue the invoice manually.",
      confirm: "Yes, send",
      cancel: "No",
    },
    cancelError: {
      title: "Couldn't cancel",
    },
    closeError: {
      title: "Couldn't close",
    },
    sendError: {
      title: "Couldn't send",
    },
    sendSuccess: {
      title: "Link sent",
      text: "The guest has received the invoice link.",
    },
    retry: "Please try again.",
  },
  balances: {
    title: "Pending balances",
    subtitle: "Bookings with an amount due.",
    total: "Total",
    paid: "Payment processed",
    loading: "Loading…",
    empty: "No pending balances.",
    emptySub: "When a booking has an amount due, it will appear here.",
    viewAll: "View all balances",
  },
  balancesDrawer: {
    title: "Pending balances",
    close: "Close",
    from: "From",
    to: "To",
    sort: "Sort",
    sortArrival: "Check-in date",
    sortProximity: "Arrival proximity",
    searchPlaceholder: "Search accommodation…",
    allAccommodations: "All accommodations",
    noResults: "No results",
    clear: "Clear",
    totalPending: "Total pending",
    ofTotal: "of {amount} {currency}",
    loading: "Loading…",
    empty: "No bookings with a pending balance.",
    end: "No more.",
    tags: {
      ended: "Stay ended",
      now: "In house",
      today: "Arrives today",
      tomorrow: "Arrives tomorrow",
      dayAfter: "Arrives in 2 days",
    },
  },
};
